import PropTypes from 'prop-types';
import { map as _map } from 'lodash';
import moment from 'moment';
import { getOverlays } from '../utils/interval';
import OverlayItem from './OverlayItem';
import './style.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var Overlay = function Overlay(_ref) {
  var period = _ref.period,
      overlays = _ref.overlays,
      getX = _ref.getX,
      vertical = _ref.vertical,
      onClick = _ref.onClick;

  if (period) {
    var periodStart = moment(period.start);
    var periodEnd = moment(period.end);
    var overlaysCfg = getOverlays(periodStart, periodEnd, overlays);

    var overlaysElms = _map(overlaysCfg, function (overlay) {
      return /*#__PURE__*/_jsx(OverlayItem, {
        overlay: overlay,
        getX: getX,
        vertical: vertical,
        onClick: onClick
      }, "".concat(overlay.key));
    });

    return /*#__PURE__*/_jsx("g", {
      children: overlaysElms
    });
  } else {
    return null;
  }
};

Overlay.propTypes = {
  period: PropTypes.shape({
    start: PropTypes.string,
    end: PropTypes.string
  }),
  getX: PropTypes.func,
  overlays: PropTypes.array.isRequired,
  vertical: PropTypes.bool,
  onClick: PropTypes.func
};
Overlay.defaultProps = {
  getX: function getX() {},
  overlays: [],
  vertical: false,
  onClick: function onClick() {}
};
export default Overlay;